module.exports = __webpack_public_path__ + "img/stoneware.e5604dd.svg";